$(document).ready(function () {
    var sliderInitialized = false;

    function initializeSlider() {
        if (!sliderInitialized && $(window).width() <= 980) {
            $('.ib-slider').slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 2,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
            sliderInitialized = true;
        }
    }

    function unslickSlider() {
        if (sliderInitialized && $(window).width() > 980) {
            $('.ib-slider').slick('unslick');
            sliderInitialized = false;
        }
    }

    // Initialize or unslick slider based on the current window size
    function checkSlider() {
        if ($('.ib-custom .product').length > 0) {
            initializeSlider();
        } else {
            unslickSlider();
        }
    }

    // MutationObserver callback function
    function handleMutations(mutationsList) {
        mutationsList.forEach(function (mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                // Check if the added nodes include a .product element
                var addedNodes = Array.from(mutation.addedNodes);
                if (addedNodes.some(node => $(node).is('.product') || $(node).find('.product').length > 0)) {
                    setTimeout(checkSlider, 1000);  // Add a small delay to ensure DOM is fully updated
                }
            }
        });
    }

    // Setup the MutationObserver
    var observer = new MutationObserver(handleMutations);
    observer.observe($('.ib-custom')[0], { childList: true, subtree: true });

    // Initial check when the document is ready
    checkSlider();

    // Handle window resize
    $(window).resize(function() {
        checkSlider();
    });
});
